
const languages = [
	{
		id: 69,
		name: "Arabic",
		langCode: 'ar',
		t: "ARABIC",
	},
	{
		id: 9,
		name: "Armenian",
		langCode: 'hy',
		t: "ARMENIAN",
	},
	{
		id: 3,
		name: "Azerbaijani",
		code: 'az',
		t: "AZERBAIJANI",
	},
	{
		id: 13,
		name: "Bulgarian",
		langCode: 'bg',
		t: "BULGARIAN",
	},
	{
		id: 15,
		name: "Belarusian",
		langCode: 'be',
		t: "BELARUSIAN",
	},
	{
		id: 24,
		name: "Croatian",
		langCode: 'hr',
		t: "CROATIAN",
	},
	{
		id: 26,
		name: "Czech",
		langCode: 'cs',
		t: "CZECH",
	},
	{
		id: 27,
		name: "Danish",
		langCode: 'da',
		t: "DANISH",
	},
	{
		id: 56,
		name: "Dutch",
		langCode: 'nl',
		t: "DUTCH",
	},
	{
		id: 88,
		name: "English",
		langCode: 'en',
		tfidf: true,
		t: "ENGLISH",
	},
	{
		id: 30,
		name: "Estonian",
		langCode: 'et',
		t: "ESTONIAN",
	},
	{
		id: 31,
		name: "Finnish",
		langCode: 'fi',
		t: "FINNISH",
	},
	{
		id: 32,
		name: "French",
		langCode: 'fr',
		t: "FRENCH",
	},
	{
		id: 33,
		name: "German",
		langCode: 'de',
		tfidf: true,
		t: "GERMAN",
	},
	{
		id: 35,
		name: "Greek",
		langCode: 'el',
		t: "GREEK",
	},
	{
		id: 38,
		name: "Hungarian",
		langCode: 'hu',
		t: "HUNGARIAN",
	},
	{
		id: 42,
		name: "Hebrew",
		langCode: 'he',
		t: "HEBREW",
	},
	{
		id: 43,
		name: "Italian",
		langCode: 'it',
		t: "ITALIAN",
	},
	{
		id: 45,
		name: "Japanese",
		langCode: 'ja',
		t: "JAPANESE",
	},
	{
		id: 49,
		name: "Korean",
		langCode: 'ko',
		t: "KOREAN",
	},
	{
		id: 50,
		name: "Latvian",
		langCode: 'lv',
		t: "LATVIAN",
	},
	{
		id: 51,
		name: "Lithuanian",
		langCode: 'lt',
		t: "LITHUANIAN",
	},
	{
		id: 85,
		name: "Macedonian",
		langCode: 'mk',
		t: "MACEDONIAN",
	},
	{
		id: 60,
		name: "Norwegian",
		langCode: 'nb',
		t: "NORWEGIAN",
	},
	{
		id: 65,
		name: "Polish",
		langCode: 'pl',
		tfidf: true,
		t: "POLISH",
	},
	{
		id: 66,
		name: "Portuguese",
		langCode: 'pt',
		t: "PORTUGUESE",
	},
	{
		id: 67,
		name: "Romanian",
		langCode: 'ro',
		t: "ROMANIAN",
	},
	{
		id: 68,
		name: "Russian",
		langCode: 'ru',
		t: "RUSSIAN",
	},
	{
		id: 71,
		name: "Serbian",
		langCode: 'sr',
		t: "SERBIAN",
	},
	{
		id: 73,
		name: "Slovak",
		langCode: 'sk',
		t: "SLOVAK",
	},
	{
		id: 74,
		name: "Vietnamese",
		langCode: 'en',
		t: "VIETNAMESE",
	},
	{
		id: 75,
		name: "Slovenian",
		langCode: 'sl',
		t: "SLOVENIAN",
	},
	{
		id: 77,
		name: "Spanish",
		langCode: 'es',
		t: "SPANISH",
	},
	{
		id: 78,
		name: "Swedish",
		langCode: 'sv',
		tfidf: true,
		t: "SWEDISH",
	},
	{
		id: 80,
		name: "Thai",
		langCode: 'th',
		t: "THAI",
	},
	{
		id: 83,
		name: "Turkish",
		langCode: 'tr',
		t: "TURKISH",
	},
	{
		id: 84,
		name: "Ukrainian",
		langCode: 'uk',
		t: "UKRAINIAN",
	},
];
export default languages;
